// =============================================================================
// casino.ts — O Cassino da Maleta (CPI da BET): prêmios possíveis ao abrir uma
// mala de dinheiro. O servidor sorteia na hora do toque; o cliente roda a
// esteira estilo abertura de caixa (issue #121) e para exatamente no
// resultado. A banca sempre ganha. Ícones são pixel art procedural
// (ui/pixelIcons.ts, casinoPrizeIcon) — zero emoji, ver CLAUDE.md.
// =============================================================================

export interface CasinoPrizeDef {
  id: string;
  nome: string;
  desc: string;      // mostrado no card quando a esteira para
  good: boolean;     // decide o som do resultado no cliente
  weight: number;    // peso no sorteio (servidor)
}

export const CASINO_PRIZES: CasinoPrizeDef[] = [
  { id: 'vida', nome: 'PLANO DE SAÚDE', desc: 'Emenda parlamentar cobre a consulta: cura 40% da sua vida.', good: true, weight: 22 },
  { id: 'voto', nome: 'COMPRA DE VOTOS', desc: 'A mala rende votos pra chapa toda (caixa 2? que caixa 2?).', good: true, weight: 22 },
  { id: 'skill', nome: 'EMENDA DO RELATOR', desc: 'Upgrade grátis: a urna abre pra você por fora da fila.', good: true, weight: 15 },
  { id: 'foro', nome: 'FORO PRIVILEGIADO', desc: '8 segundos de imunidade total (a lei é igual pra todos*).', good: true, weight: 12 },
  { id: 'cpi', nome: 'CPI DA BET', desc: 'Convocado a depor: a chapa perde 15% dos votos acumulados.', good: false, weight: 13 },
  { id: 'nada', nome: 'ACABOU EM PIZZA', desc: 'Investigação arquivada, ninguém punido, nada acontece.', good: false, weight: 16 },
  // GOLPE DE MESTRE (issue #98): nunca sai no sorteio (weight 0) — é GARANTIDO
  // quando quem abre a maleta cumpre a receita de evolução (arma nv 8 + passiva).
  { id: 'golpe', nome: 'GOLPE DE MESTRE', desc: 'Receita cumprida: a maleta financia a EVOLUÇÃO da arma pra versão suprema.', good: true, weight: 0 },
];

export const CASINO_PRIZE_TABLE: Record<string, CasinoPrizeDef> =
  Object.fromEntries(CASINO_PRIZES.map((p) => [p.id, p]));
